module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/dane_zagraniczne-6d460c4a.svg";